// Centralized section config for navigation and rendering
export const SECTIONS = [
  { id: 'about', label: 'About', component: 'About' },
  { id: 'experience', label: 'Experience', component: 'Experience' },
  { id: 'education', label: 'Education', component: 'Education' },
  { id: 'skills', label: 'Skills', component: 'Skills' },
  { id: 'projects', label: 'Projects', component: 'Projects' },
  { id: 'resume', label: 'Resume', component: 'Resume' },
];
